import { IconProps } from '../types';
import classnames from 'classnames';

/**
 * Maestro acceptance mark — the red and blue discs with the violet overlap.
 *
 * Artwork: aaronfagan/svg-credit-card-payment-icons `logo/maestro.svg` (fetched 2026-09-15),
 * Apache-2.0. Unmodified apart from cropping the 780×500 canvas to the discs. Shown to indicate
 * that the card is accepted at checkout, which is what the scheme's acceptance-mark rules provide
 * the artwork for.
 */
export default function MaestroIcon(props: IconProps) {
  const { className, style } = props;

  return (
    <svg className={classnames('h-4', className)} viewBox="100 68 580 364" fill="none" style={style}>
      <path d="M465.769 113.811H314.195V386.211H465.769V113.811Z" fill="#7673C0" />
      <path
        d="M323.822 250.033C323.794 223.796 329.736 197.895 341.199 174.294C352.662 150.693 369.346 130.009 389.985 113.809C364.43 93.7255 333.74 81.2366 301.422 77.77C269.105 74.3033 236.464 79.9986 207.231 94.2052C177.997 108.412 153.35 130.556 136.107 158.108C118.863 185.66 109.719 217.507 109.719 250.009C109.719 282.512 118.863 314.359 136.107 341.911C153.35 369.462 177.997 391.607 207.231 405.814C236.464 420.02 269.105 425.715 301.422 422.249C333.74 418.782 364.43 406.293 389.985 386.21C369.352 370.015 352.673 349.339 341.21 325.746C329.747 302.154 323.801 276.263 323.822 250.033Z"
        fill="#EB001B"
      />
      <path
        d="M670.228 250.034C670.22 282.531 661.072 314.37 643.827 341.914C626.583 369.459 601.939 391.597 572.71 405.8C543.482 420.002 510.847 425.697 478.536 422.233C446.224 418.769 415.538 406.286 389.984 386.21C410.609 370.001 427.284 349.32 438.75 325.726C450.216 302.132 456.173 276.243 456.173 250.01C456.173 223.778 450.216 197.888 438.75 174.295C427.284 150.701 410.609 130.019 389.984 113.81C415.538 93.7202 446.228 81.2253 478.547 77.7536C510.867 74.282 543.511 79.9737 572.748 94.1783C601.985 108.383 626.636 130.527 643.883 158.079C661.129 185.632 670.275 217.481 670.276 249.986L670.228 250.034Z"
        fill="#00A1DF"
      />
    </svg>
  );
}
